/*export interface ReferralDisplay{
    firstname: string,
    lastname: string,    
    reflabel?: string,
    referencename?: string,
    totalresponses?:string,
    email?:string,
    status?: string,
}*/
export interface Referral{
    id?: string,
    referralid?: string,
    firstname?: string,
    lastname?: string,
    reflabel?: string,
    startdate?: string,
    summaryurl?: string
    referenceid?: string,
    referencetype?: string,
    referencename?: string,
    noofparticipantsmin?: string,
    noofparticipantsmax?: string,
    points?: number,
// mainref information
    refownerid?: string,
    refemail?: string,
    refprefix?: string,
    reffirstname?: string,
    reflastname?: string,
    refcompany?: string,
    refauthorid?:string,
    
    enddate?:string,
    finishdate?:string,
    totalresponses?:string,
    totalinvited?:string,

    entityid?: string,
    email?:string,
    referrers ?: Array<any>,
    status?: string,
    action?: string,    
//    referencemaster: IReference
    //mainreferrer: IMainreferrer,
    //entity: IEntity
}